export const FemaleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_8856_17767)">
      <path
        d="M20.7419 15.5555C26.4696 9.82778 35.756 9.82778 41.4837 15.5555C47.2114 21.2832 47.2114 30.5696 41.4837 36.2973C35.756 42.025 26.4696 42.025 20.7419 36.2973C15.0142 30.5696 15.0142 21.2832 20.7419 15.5555Z"
        stroke={props.color ?? "#454643"}
        strokeWidth="2.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.1124 57.0387L31.1128 41.1299M26.1147 52.0409L36.1102 52.0409"
        stroke={props.color ?? "#454643"}
        strokeWidth="2.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8856_17767">
        <rect width="44" height="44" fill="white" transform="translate(31.1128) rotate(45)" />
      </clipPath>
    </defs>
  </svg>
)
